import styles from "./LoginGymSelect.module.scss";
import useAppSelector from "../../../hooks/useAppSelector";
import React, {useEffect, useState} from "react";
import {IMultiGymInfo, setFranchiseGymsList} from "../../../store/multiGyms/multiGymsSlice";
import {MultiGymService} from "../../../services/multiGym.service";
import useAppDispatch from "../../../hooks/useAppDispatch";
import selectArrow from "../../../assets/images/icons/select-arrow.svg";
import {useTranslation} from "react-i18next";

interface ILoginGymSelectProps {
    selectedGym: null | IMultiGymInfo;
    setSelectedGym: (el: IMultiGymInfo) => void;
    mode: "dark" | "light";
}

const LoginGymSelect: React.FC<ILoginGymSelectProps> = ({selectedGym, setSelectedGym, mode}) => {
    const dispatch = useAppDispatch();
    const {t} = useTranslation();

    const {activeGym, franchiseGymsList} = useAppSelector(state => state.multiGymsSlice);

    const [dropDownVisible, setDropDownVisible] = useState(false);

    useEffect(() => {
        getFranchiseGyms();
    }, []);

    const getFranchiseGyms = async () => {
        try {
            let token = localStorage.getItem("refresh_token");
            if (!token) token = "";
            const response = await MultiGymService.getFranchiseGyms(token);
            dispatch(setFranchiseGymsList(response.data.data));
        } catch (e) {
        }
    }

    const renderDropDownItem = (el: IMultiGymInfo) => {

        const clickOnDropDownItem = (el: IMultiGymInfo) => {
            setSelectedGym(el);
            setDropDownVisible(false);
        }

        return (
            <div key={el.id} className={styles.item} onClick={() => clickOnDropDownItem(el)}>
                <p className={styles.itemTitle}>{el.name}</p>
                <p className={styles.itemText}>{el.country}, {el.city} {el.street} {el.streetNumber}</p>
            </div>
        )
    }

    return (
        <>
            <label className={`${styles.selectLabel} ${mode === "light" && styles.light}`}>{t("SelectGym")}</label>
            <div className={`${styles.selectContainer} ${mode === "light" && styles.light}`}>
            {
                selectedGym ? (
                    <p className={styles.selectText}>{selectedGym.name}</p>
                ) : (
                    <p className={styles.selectText}>{Object.keys(activeGym).length ? activeGym.name : "Select..."}</p>
                )
            }
            <img
                className={styles.arrow}
                src={selectArrow}
                alt={"arrow"}
                onClick={() => setDropDownVisible(!dropDownVisible)}
            />
            {
                dropDownVisible && (
                    <div className={styles.dropDownWrapper}>
                        {
                            franchiseGymsList.map(el => renderDropDownItem(el))
                        }
                    </div>
                )
            }
        </div>
        </>
    )


}
export default LoginGymSelect